function toMetricNumber(value, fallback = 0) {
  const numeric = Number(value ?? fallback);
  return Number.isFinite(numeric) ? numeric : fallback;
}

function normalizeMetrics(metrics, data) {
  return {
    audienceSize: toMetricNumber(metrics.audienceSize ?? data?.audienceSize),
    sent: toMetricNumber(metrics.sent),
    delivered: toMetricNumber(metrics.delivered),
    bounced: toMetricNumber(metrics.bounced),
    uniqueClickers: toMetricNumber(metrics.uniqueClickers),
    totalClicks: toMetricNumber(metrics.totalClicks),
    unsubscribes: toMetricNumber(metrics.unsubscribes),
    spamComplaints: toMetricNumber(metrics.spamComplaints),
    deliveryFailures: toMetricNumber(metrics.deliveryFailures),
    opens: metrics.opens == null ? null : toMetricNumber(metrics.opens),
    clickBreakdown: Array.isArray(metrics.clickBreakdown)
      ? metrics.clickBreakdown
      : [],
  };
}

export function normalizeNewsletterCampaign(docId, data) {
  const metrics = data?.metrics ?? {};
  return {
    id: docId,
    campaignId: data?.campaignId ?? docId,
    issueKey: data?.issueKey ?? docId,
    issueName: data?.issueName ?? docId,
    subject: data?.subject ?? '',
    previewText: data?.previewText ?? '',
    status: data?.status ?? 'draft',
    metricsStatus: data?.metricsStatus ?? 'pending',
    audienceSize: toMetricNumber(data?.audienceSize ?? metrics.audienceSize),
    sentAt: data?.sentAt ?? null,
    testSentAt: data?.testSentAt ?? null,
    updatedAt: data?.updatedAt ?? null,
    createdAt: data?.createdAt ?? null,
    lastError: data?.lastError ?? null,
    metrics: normalizeMetrics(metrics, data),
  };
}
